export const mastheadMeta = {
  dateLabel: "2026年9月12日 星期六",
  issue: "总第 482 期",
  hotWords: ["#顶流录音流出", "#旧照回应反转", "#夜店偶遇", "#工作室声明", "#粉丝澄清贴"],
};

export const navLinks = [
  { label: "首页", href: "#top" },
  { label: "今日热帖", href: "#trending" },
  { label: "爆料帖", href: "#trending" },
  { label: "精华热榜", href: "#essence" },
  { label: "最新回复", href: "#live" },
  { label: "讨论区", href: "#discussion" },
];

export const heroStats = [
  { label: "今日新增帖", value: "1,286", icon: "ri-add-circle-line" },
  { label: "进行中的事件", value: "47", icon: "ri-radar-line" },
  { label: "讨论区在线", value: "23,904", icon: "ri-group-line" },
  { label: "已收录精华帖", value: "8,120", icon: "ri-medal-line" },
];

export const trendingTabs = ["全部动态", "今日热帖", "爆料帖", "争议反转"];

export type TrendingPost = {
  id: string;
  title: string;
  summary: string;
  tag: string;
  kind: "hot" | "expose" | "dispute";
  heat: string;
  replies: number;
  author: string;
  time: string;
  image?: string;
};

export const trendingPosts: TrendingPost[] = [
  {
    id: "t1",
    title: "录音门完整时间线梳理：从凌晨一条动态到工作室深夜回应",
    summary:
      "帖子把三天内分散在不同平台的截图按时间顺序整理成一条线，并标注了对不上的三个时间点。楼主称已把原始音频交给第三方做波形比对，结果预计今晚公布，讨论区正围绕这段空白两小时激烈补充线索。",
    tag: "今日头条",
    kind: "hot",
    heat: "98.2万",
    replies: 1624,
    author: "深巷记录员",
    time: "12 分钟前",
    image:
      "https://readdy.ai/api/search-image?query=moody%20editorial%20still%20life%20of%20scattered%20newspapers%20and%20a%20vintage%20camera%20on%20a%20walnut%20desk%2C%20warm%20amber%20desk%20lamp%20light%2C%20dramatic%20shadows%2C%20muted%20crimson%20and%20olive%20tones%2C%20cinematic%20documentary%20style%2C%20high%20detail%2C%20shallow%20depth%20of%20field&width=900&height=560&seq=heiliaocom-trending-lead&orientation=landscape",
  },
  {
    id: "t2",
    title: "旧照翻红第二弹：拍摄年份或早于当事人自述两年",
    summary:
      "对比 EXIF 元数据与当年的活动行程表，楼主指出照片里的背景店面直到次年才开业。",
    tag: "爆料帖",
    kind: "expose",
    heat: "64.7万",
    replies: 892,
    author: "楼道摄影师",
    time: "26 分钟前",
  },
  {
    id: "t3",
    title: "夜店偶遇视频被逐帧拆解，网友发现背景音乐对不上",
    summary: "音频轨与画面里 DJ 的手势差了约 0.8 秒，讨论区已经分成两派各自补充证据。",
    tag: "争议反转",
    kind: "dispute",
    heat: "51.3万",
    replies: 1103,
    author: "零点拆片人",
    time: "41 分钟前",
  },
  {
    id: "t4",
    title: "工作室声明逐句翻译：这四句话其实什么都没说",
    summary: "把公关稿拆成主语、谓语、时间副词，逐句标注了留白和模糊处理的位置。",
    tag: "今日热帖",
    kind: "hot",
    heat: "43.1万",
    replies: 745,
    author: "文字勘误君",
    time: "1 小时前",
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20an%20audio%20cassette%20tape%20and%20a%20microphone%20on%20a%20dark%20wooden%20table%2C%20warm%20golden%20rim%20light%2C%20moody%20investigative%20aesthetic%2C%20muted%20earthy%20tones%2C%20film%20grain%2C%20high%20detail&width=520&height=520&seq=heiliaocom-trending-thumb-a&orientation=squarish",
  },
  {
    id: "t5",
    title: "爆料帖合集：过去半年被删掉的十一条动态全文备份",
    summary: "楼主做了完整备份并标注发布时间，讨论区正在逐条核对哪些内容是真的被删除过。",
    tag: "爆料帖",
    kind: "expose",
    heat: "38.6万",
    replies: 613,
    author: "备份仓库长",
    time: "1 小时前",
  },
  {
    id: "t6",
    title: "澄清长图被找出拼接痕迹，边角有三像素色差",
    summary: "放大到 800% 后能看到两段背景纹理的走向不一致，这个细节成了今晚最大的反转点。",
    tag: "争议反转",
    kind: "dispute",
    heat: "35.9万",
    replies: 528,
    author: "像素猎人",
    time: "2 小时前",
    image:
      "https://readdy.ai/api/search-image?query=silhouette%20of%20a%20city%20night%20skyline%20seen%20through%20a%20rain%20covered%20window%2C%20warm%20streetlight%20bokeh%2C%20moody%20cinematic%20mood%2C%20deep%20shadow%2C%20warm%20amber%20highlights%2C%20high%20detail&width=520&height=520&seq=heiliaocom-trending-thumb-b&orientation=squarish",
  },
  {
    id: "t7",
    title: "当事人小号被顺藤摸瓜，头像图库来源是真·十年前的免费素材",
    summary: "从图库编号反查到上传年份，讨论区据此重新排了一遍事件的时间顺序。",
    tag: "今日热帖",
    kind: "hot",
    heat: "29.4万",
    replies: 402,
    author: "图源考古队",
    time: "3 小时前",
  },
];

export type EssencePost = {
  rank: number;
  title: string;
  author: string;
  heat: string;
  replies: number;
  badge: string;
  time: string;
};

export const essencePosts: EssencePost[] = [
  {
    rank: 1,
    title: "把三个平台的截图拼成一条完整时间线，这才是事件真正的样子",
    author: "深巷记录员",
    heat: "98.2万",
    replies: 1624,
    badge: "全网转载",
    time: "今天 02:14",
  },
  {
    rank: 2,
    title: "公关稿逐句精读：主语省略的地方，往往就是最想藏的地方",
    author: "文字勘误君",
    heat: "43.1万",
    replies: 745,
    badge: "编辑推荐",
    time: "今天 01:38",
  },
  {
    rank: 3,
    title: "被删动态完整备份，附时间戳与存档快照对照表",
    author: "备份仓库长",
    heat: "38.6万",
    replies: 613,
    badge: "资料价值",
    time: "昨天 23:52",
  },
  {
    rank: 4,
    title: "从图库编号反推上传年份，顺手重排了整条时间线",
    author: "图源考古队",
    heat: "29.4万",
    replies: 402,
    badge: "硬核考据",
    time: "昨天 22:07",
  },
  {
    rank: 5,
    title: "澄清图拼接痕迹放大 800% 逐像素对照，附对比动图",
    author: "像素猎人",
    heat: "35.9万",
    replies: 528,
    badge: "技术流",
    time: "昨天 21:20",
  },
  {
    rank: 6,
    title: "给围观者的理性指南：现在能确定的和还不能确定的分别有哪些",
    author: "冷静旁观席",
    heat: "21.8万",
    replies: 336,
    badge: "讨论规范",
    time: "昨天 19:44",
  },
  {
    rank: 7,
    title: "半年内被反复引用的十二条关键截图，逐条标注可信度",
    author: "溯源小组",
    heat: "18.5万",
    replies: 274,
    badge: "资料价值",
    time: "昨天 18:02",
  },
  {
    rank: 8,
    title: "一份好帖子的自查清单：来源、时间、出处一样都不能少",
    author: "黑料小编",
    heat: "12.7万",
    replies: 198,
    badge: "社区公约",
    time: "昨天 16:30",
  },
];

export type LiveReply = {
  id: string;
  author: string;
  action: string;
  content: string;
  target: string;
  time: string;
};

export const liveReplies: LiveReply[] = [
  {
    id: "l1",
    author: "薄荷味刀片",
    action: "补充线索",
    content: "那天下午的航班其实是延误的，落地时间比帖子里写的晚了两小时。",
    target: "录音门完整时间线",
    time: "刚刚",
  },
  {
    id: "l2",
    author: "阿栗不吃栗",
    action: "反驳",
    content: "背景那家店我记得当年冬天就开过，翻出来一张旧照可以对照。",
    target: "旧照翻红第二弹",
    time: "18 秒前",
  },
  {
    id: "l3",
    author: "楼下的猫",
    action: "跟帖",
    content: "逐帧那段我把原片重下了一遍，时间码确实对不上号。",
    target: "夜店偶遇视频拆解",
    time: "1 分钟前",
  },
  {
    id: "l4",
    author: "夜航船工",
    action: "补充线索",
    content: "找到一份当年活动的日程表，正好能卡住那个时间点。",
    target: "被删动态完整备份",
    time: "2 分钟前",
  },
  {
    id: "l5",
    author: "清醒的第三人",
    action: "反驳",
    content: "这个推断跳得太快了，中间还缺一环证据，先别急着下结论。",
    target: "工作室声明逐句翻译",
    time: "3 分钟前",
  },
  {
    id: "l6",
    author: "像素猎人",
    action: "补充线索",
    content: "把那块区域再放大到 1600%，边缘有一条很规整的直线。",
    target: "澄清长图拼接痕迹",
    time: "5 分钟前",
  },
  {
    id: "l7",
    author: "资料来源库",
    action: "跟帖",
    content: "已把对比图存进存档区，编号 0926-17，方便以后引用。",
    target: "精华帖整理合集",
    time: "7 分钟前",
  },
  {
    id: "l8",
    author: "慢慢看的人",
    action: "反驳",
    content: "截图右下角的水印是后加的，不能当作原始证据来用。",
    target: "半年内十二条关键截图",
    time: "9 分钟前",
  },
];

export type DiscussionReply = {
  id: string;
  author: string;
  role: "跟帖" | "反驳" | "补充线索";
  content: string;
  likes: number;
  time: string;
};

export const discussionThread = {
  title: "录音门完整时间线梳理：从凌晨一条动态到工作室深夜回应",
  author: "深巷记录员",
  time: "今天 02:14",
  views: "86.4万",
  replies: 1624,
  repliesList: [
    {
      id: "d1",
      author: "薄荷味刀片",
      role: "补充线索",
      content:
        "补一个细节：当天航班的落地时间比帖子里写的晚了将近两小时，如果按真实落地时间重新排，中间那段空白就能填上大半。",
      likes: 328,
      time: "1 小时前",
    },
    {
      id: "d2",
      author: "清醒的第三人",
      role: "反驳",
      content:
        "不太认同第二条推断，从一张旧照的店招直接跳到行程矛盾，中间至少缺一环证据，建议先把当年的开业时间确认了再谈。",
      likes: 214,
      time: "48 分钟前",
    },
    {
      id: "d3",
      author: "夜航船工",
      role: "补充线索",
      content:
        "我翻到一份当年的活动日程表，上面标注的时间点和楼主整理的第一版对不上，已经截图放到存档区了，编号 0926-21。",
      likes: 176,
      time: "32 分钟前",
    },
    {
      id: "d4",
      author: "楼下的猫",
      role: "跟帖",
      content: "这条时间线是目前看得最舒服的一版，至少把出处一条条标出来了，等波形比对结果。",
      likes: 92,
      time: "19 分钟前",
    },
  ] as DiscussionReply[],
};

export type TimelineItem = {
  time: string;
  title: string;
  desc: string;
  status: "done" | "current" | "upcoming";
};

export const eventTimeline: TimelineItem[] = [
  {
    time: "9 月 9 日 02:14",
    title: "凌晨动态发布",
    desc: "当事人发布一条短文，三小时后删除，帖子存档区已保留快照。",
    status: "done",
  },
  {
    time: "9 月 10 日 20:40",
    title: "录音片段流出",
    desc: "一段 47 秒音频出现在两个平台，讨论区开始逐句听写整理。",
    status: "done",
  },
  {
    time: "9 月 11 日 15:06",
    title: "旧照被翻出",
    desc: "网友对比 EXIF 信息，指出拍摄年份与公开行程存在矛盾。",
    status: "done",
  },
  {
    time: "9 月 12 日 01:38",
    title: "工作室深夜回应",
    desc: "发布一页声明，讨论区正在逐句翻译其中的留白与模糊表述。",
    status: "current",
  },
  {
    time: "9 月 12 日 22:00（预计）",
    title: "波形比对结果公布",
    desc: "第三方机构称当晚给出比对结论，讨论区已开好专题帖等待更新。",
    status: "upcoming",
  },
];

export const hotTopicTags = [
  { label: "顶流录音流出", count: "3.2万帖" },
  { label: "旧照回应反转", count: "1.8万帖" },
  { label: "工作室声明", count: "1.1万帖" },
  { label: "粉丝澄清贴", count: "9,420帖" },
  { label: "夜店偶遇", count: "7,650帖" },
  { label: "图源考据", count: "5,308帖" },
];

export const downloadHighlights = [
  { icon: "ri-flashlight-line", title: "新帖秒推", desc: "热帖与爆料帖更新即推送到桌面，不用反复刷新。" },
  { icon: "ri-bookmark-3-line", title: "一键存档", desc: "喜欢的帖子与线索随时收藏，离线也能回看。" },
  { icon: "ri-history-line", title: "进度记忆", desc: "自动记住每次离开的位置，接着上次的讨论往下看。" },
];